<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const props = defineProps({
  category: {
    required: true,
    type: String,
  },
  index: {
    required: true,
    type: Number,
  },
});

const sortOrder = computed(() => {
  if (store.state.projectsMap.projectsList[props.index].sortBy === props.category) {
    return store.state.projectsMap.projectsList[props.index].sortOrder;
  }
  return null;
});

function sortBy() {
  store.dispatch('projectsMap/sortProjectsTable', {
    sortBy: props.category,
    index: props.index,
  });
}
</script>

<template>
  <th :aria-sort="sortOrder" role="columnheader" scope="col">
    <button
      @click="sortBy"
      @keydown.down.stop
      @keydown.up.stop
      class="c-projects-table__sort-action"
      type="button"
    >
      <slot />
      <svg focusable="false" aria-hidden="true">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#triangle"></use>
      </svg>
    </button>
  </th>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/mixins/buttons';
@import '@/ui/styles/mixins/focus';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/units';

.c-projects-table__sort-action {
  @include iconButton(rem(12px));
  @include removeDefaultButtonStyling();
  justify-content: flex-start;
  padding: rem(13px) $spacing-large;
  width: 100%;
  color: $color-brand-one;
  cursor: pointer;

  & > svg {
    display: none;
    margin-left: rem(11px);

    [aria-sort] & {
      display: block;
    }

    [aria-sort='descending'] & {
      transform: rotate(180deg);
    }
  }
}
</style>
